//******************************************************************************************************************//
const listItems = document.querySelector("#legacy-custom-html-slider");
const header = document.querySelector("#legacy-header");
const htmlSliderConfig = {
  interval: null,
  displayIndex: 0,
  displayInterval: 1000,
  isExecutedOnce: false,
  customSliderEl: listItems ? listItems.getElementsByTagName("p") : null,
  sliderParent: listItems,
  header: header,
  lastScrollPosition: 0,
  sliderParentHeight: listItems ? listItems.clientHeight : 0,
  headerHeight: header ? header.clientHeight : 0,
  headerLogoLink: "https://cdn.shopify.com/s/files/1/0694/3909/5058/files/17.png?v=1673710727",
  headerLogoLinkNeg1: "https://cdn.shopify.com/s/files/1/0694/3909/5058/files/20.png?v=1673944157",
  headerLogoLinkNeg2: "https://cdn.shopify.com/s/files/1/0694/3909/5058/files/19.png?v=1673944157",
  headerLogoLinkNeg3: "https://cdn.shopify.com/s/files/1/0694/3909/5058/files/18.png?v=1673710727",
};

initHTMLSlider = function(){
  if(htmlSliderConfig.header){
    initUIScrollHandler();
    let headerBackground = document.querySelector('[data-header-background]');
    if(headerBackground){
      let backgroundColor = headerBackground.getAttribute('data-header-background');
      setHeaderBackgroundColor(backgroundColor);
    }
  }
  
  if(htmlSliderConfig.customSliderEl && htmlSliderConfig.customSliderEl.length > 1){
    hideHtmlSliderElements(htmlSliderConfig.customSliderEl, htmlSliderConfig.displayIndex);
  }

  htmlSliderConfig.interval = setInterval(() => {
    if(!htmlSliderConfig.isExecutedOnce){
      hideHtmlSliderElements(htmlSliderConfig.customSliderEl, htmlSliderConfig.displayIndex)
    }
    else{
      clearInterval(htmlSliderConfig.interval);
    }
  }, htmlSliderConfig.displayInterval);
}

toggleHeaderLogo = function(link, legacyLogoLink, fontColor){
  if(link){
    link.querySelector("img").src = legacyLogoLink;
    let legacyLogoLinkSrcSet = legacyLogoLink + "&width=50 50w, " +
                                legacyLogoLink + "&width=100 100w, " +
                                legacyLogoLink + "&width=150 150w, " +
                                legacyLogoLink + "&width=200 200w, " +
                                legacyLogoLink + "&width=250 250w, " +
                                legacyLogoLink + "&width=300 300w, " +
                                legacyLogoLink + "&width=350 350w, " +
                                legacyLogoLink + "&width=400 400w, " +
                                legacyLogoLink + "&width=500 500w";
    link.querySelector("img").srcset = legacyLogoLinkSrcSet;
    
  }
}

hideHtmlSliderElements = function(elements, displayIndex){
  if(elements){
    let elem = elements[displayIndex];
    let backgroundColor = elem.getAttribute("data-background-color");
    let fontColor = elem.getAttribute("data-font-color") ? elem.getAttribute("data-font-color") : '#ffffff';
    let headerLogoLink = htmlSliderConfig.header.querySelector('.header__heading-link');
    

    if(fontColor) elem.style.color = fontColor;
    if(backgroundColor){
      elem.style.backgroundColor = backgroundColor;  
      setHeaderBackgroundColor(backgroundColor);
      if(backgroundColor == '#ffffff'){
        //htmlSliderConfig.header.classList.add('color-background-1');
        if(fontColor){
          if(fontColor == '#05387c'){
            toggleHeaderLogo(headerLogoLink, htmlSliderConfig.headerLogoLinkNeg1, fontColor);
            htmlSliderConfig.header.classList.add('header-color-neg-1');
          }
          else if(fontColor == '#45b7cf'){
            toggleHeaderLogo(headerLogoLink, htmlSliderConfig.headerLogoLinkNeg2, fontColor);
            htmlSliderConfig.header.classList.add('header-color-neg-2');
          }
          else if(fontColor == '#f64f31'){
            toggleHeaderLogo(headerLogoLink, htmlSliderConfig.headerLogoLinkNeg3, fontColor);
            htmlSliderConfig.header.classList.add('header-color-neg-3');
          }
        }
      }
      else{
        //htmlSliderConfig.header.classList.remove('color-background-1');
        toggleHeaderLogo(headerLogoLink, htmlSliderConfig.headerLogoLink, "#ffffff");
        htmlSliderConfig.header.classList.remove('header-color-neg-1');
        htmlSliderConfig.header.classList.remove('header-color-neg-2');
        htmlSliderConfig.header.classList.remove('header-color-neg-3');
      }
    } 
    
    for (const child of elem.children) {
      let fontFamily = child.getAttribute("data-font-family");
      let fontSize = child.getAttribute("data-font-size");
      if(fontFamily){
        child.style.fontFamily = fontFamily;
      }
      if(fontSize){
        child.style.fontSize = fontSize;
      }
    }
    
    for(let i=0; i < elements.length; i++){
      let elem = elements[i];
      elem.style.display = 'flex';
      if(i !== displayIndex){
        elem.style.display = 'none';
      }
    }
  
    if(displayIndex < htmlSliderConfig.customSliderEl.length-1){
      htmlSliderConfig.displayIndex += 1;
    }
    else if(displayIndex >= htmlSliderConfig.customSliderEl.length-1){
      htmlSliderConfig.isExecutedOnce = true;
      htmlSliderConfig.displayIndex = 0;
    } 
  }
}

setHeaderBackgroundColor = function(backgroundColor){
  if(backgroundColor){
    let mobileNavHeader = document.querySelector('#menu-drawer');
    let headerCartCountBubble = htmlSliderConfig.header.querySelector('.cart-count-bubble');
    htmlSliderConfig.header.style.backgroundColor = backgroundColor;
    if(headerCartCountBubble){
      headerCartCountBubble.style.color = backgroundColor;
    }
    if(mobileNavHeader){
      mobileNavHeader.style.backgroundColor = backgroundColor;
      let mobileNavSub = document.querySelector('.menu-drawer__submenu');
      if(mobileNavSub){
        mobileNavSub.style.backgroundColor = backgroundColor;
      }
    }
  }
}

initUIScrollHandler = function(){
  document.onscroll = (event) => {
    if(!htmlSliderConfig.isExecutedOnce && htmlSliderConfig.customSliderEl){
      htmlSliderConfig.lastScrollPosition = window.scrollY;
      let scrollThreshold = parseInt(htmlSliderConfig.sliderParentHeight + htmlSliderConfig.headerHeight);
      if(htmlSliderConfig.lastScrollPosition >= scrollThreshold){
        clearInterval(htmlSliderConfig.interval);
        hideHtmlSliderElements(htmlSliderConfig.customSliderEl, htmlSliderConfig.customSliderEl.length-1);
      }
    }
  }
}

initHTMLSlider();



























